export default {
  namespaced: true,
  maintenance: {
    field_name: "Nome do campo",
    field: "campo",
    move: "Mover",
    cancel: "Cancelar",
    move_above: "Mover acima",
    move_below: "Mover abaixo",
    moving: "Movendo:",
    move_to_top: "Mover para o início",
    move_to_bottom: "Mover para o final",
    unknown_field: "Campo desconhecido",
    confirm_delete_item: "Tem certeza de que deseja excluir o item?",
    visibility: "Visibilidade",
    conditional: "Tornar condicional",
    previous_question: "Pergunta anterior...",
    select_placeholder: "Selecione...",
    clear: "Limpar",
    always_visible: "Sem condições: este campo está sempre visível.",
    auto_fill: "Preenchimento automático",
    enable: "Ativar",
    action_to_apply: "Ação a aplicar",
    copy_reference_value: "Copiar o valor do campo de referência",
    apply_new_value: "Aplicar novo valor",
    copy_other_value: "Copiar valor de outro campo",
    overwrite_on_save: "Sobrescrever ao salvar (overwrite)",
    value_to_apply: "Valor a aplicar (new_value)",
    enter_value: "Digite o valor...",
    field_to_copy: "Campo a copiar",
    select_other_field: "Selecione outro campo...",
    auto_fill_note: "Nota: será avaliado em tempo de execução usando o operador selecionado.",
    no_auto_fill: "Sem regras: este campo não é preenchido automaticamente.",
    contains: "Contém",
    empty: "Vazio",
    not_empty: "Não vazio",
    search_text: "Texto a pesquisar...",
    value_placeholder: "Valor...",
    can_crop: "Permitir recorte",
    file_upload: {
      paste_image: "Cole uma imagem aqui com Ctrl+V",
      images: "imagens",
      minimum: "mínimo {min}",
      min_images_required: "Você deve adicionar pelo menos {min} imagens.",
    },
    media_config: {
      min_required: "O mínimo é obrigatório",
      max_required: "O máximo é obrigatório",
      min_non_negative_integer: "O mínimo deve ser um inteiro positivo ou zero",
      max_greater_than_zero: "O máximo deve ser maior que zero",
      min_not_greater_than_max: "O mínimo não pode ser maior que o máximo",
      max_not_less_than_min: "O máximo não pode ser menor que o mínimo",
    },
    title: "Manutenção",
    maintenance_crew: "Equipes de Manutenção",
    maintenance_companies: "Empresas De Manutenção",
    maintenance_templates: "Modelos De Manutenção",
    maintenance_forms: "Formulários De Manutenção",
    name: "Nome",
    address: "Endereço",
    manager_name: "Nome do gerente",
    manager_plate: "Telefone do gerente",
    country_name: "País",
    site: "Site",
    document_number: "Número do documento",
    facility: "Instalação",
    select: "Select",
    multiple_select: "Seleção múltipla",
    camera: "Câmera",
    asset: "Ativo",
    text_answer: "Resposta de texto",
    format: "Formato",
    short_answer: "Resposta curta",
    paragraph: "Parágrafo",
    checkbox: "Caixa de seleção",
    date_time: "Data e hora",
    media: "Mídia",
    slider: "Controle deslizante",
    min: "Mínimo",
    max: "Máximo",
    increment: "Incremento",
    annotation: "Anotação",
    signature: "Assinatura",
    location: "Localização",
    instruction: "Instrução",
    field_types: "Tipos de campo",
    field_type_config: "Configuração do tipo de campo",
    preview: "Visualização",
    date: "Data",
    time: "Hora",
    required: "Obrigatório",
    show_in_app: "Mostrar no App",
    question: "Pergunta",
    type_response: "Tipo de resposta",
    go_back: "Voltar",
    create_template: "Criar modelo",
    update_template: "Atualizar modelo",
    template_name: "Nome do modelo",
    form_name: "Nome do formulario",
    add_new_field: "Adicionar novo campo",
    add_new_fileds: "Adicionar novos campos",
    addForm: 'Adicionar form',
    addTemplate: 'adicionar template',
    serviceOrder: 'ordem de serviço',
    add_new_fields: 'Nenhum campo adicionado',
    template: 'Modelo',
    choose_an_option: 'Selecione uma opção',
    select: 'Selecionar',
    number: 'Número',
    number_config: {
      min: 'Mínimo',
      max: 'Máximo',
      help_text: 'Número (mínimo, máximo)',
      min_must_be_less_than_max: 'O mínimo deve ser menor que o máximo',
      max_must_be_greater_than_min: 'O máximo deve ser maior que o mínimo',
      must_be_between: '{field} deve estar entre {min} e {max}.',
    },
    form_validations: {
      name: 'Defina um nome para este campo',
      type: 'Defina um tipo para este campo',
    },
    messages: {
      created_success: 'Item Criado com sucesso',
      updated_success: 'Item atualizado com sucesso'
    },
    crew: {
      description: 'Descrição',
      leader: 'Líder',
      users: 'Usuários',
      company: 'Empresa'
    },
    status: {
      pending: 'Pendente',
      in_review: 'Em revisão',
      in_progress: 'Em andamento',
      finished: 'Finalizado',
      canceled: 'Cancelado',
      latest_status: 'Último status',
    },
    maintenance_form: "Formulário De Manutenção",
    export: "Exportar",
  },
};
